import { ErrorFallbackScreen } from 'components/screens';
import { Availability, AvailabilityHeader } from 'modules/availability';
import { Layout } from 'modules/minimal-ui-theme';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';

export const AvailabilityPage = () => {
  const { isEnabled, isLoading } = useFeatureToggle(
    FeatureFlag.PRO_TALENT_AVAILABILITY
  );

  if (isLoading) return null;

  if (!isEnabled) {
    return <ErrorFallbackScreen />;
  }

  return (
    <Layout header={<AvailabilityHeader />}>
      <Availability />
    </Layout>
  );
};
